import PropTypes from 'prop-types'
export const PageProps = PropTypes.shape({
  nextPage: PropTypes.func,
  prevPage: PropTypes.func,
  setPage: PropTypes.func
})